import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import Auth from './components/Common/Auth';
import App from './App';
import Admin from './Admin';
import registerServiceWorker from './registerServiceWorker';


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);
ReactDOM.render(    
    <Provider store={store}>
        <ConnectedRouter history={history}>
            {Auth.isAdminPage(history.location) ? <Admin /> : < App />}
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root'));

registerServiceWorker();
